import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { Button, Tooltip } from 'components';
import SubmitModal from "../../components/layout/components/submitModal";
import { isAuditor } from 'utils';
import { isNil, omit, isEmpty } from 'lodash';
import { getLocalString, localNames } from "utils/localisation.service";
import { handleSubmit } from "utils";
import { submitTask, updateFormField } from "store/forms/actions";
import { ReturnModal } from './components';

const FormFooter = ({ actions, current, setCurrent, currentSubTab, steps, tabs }) => {
  const locales = useSelector(state => state.forms?.localeStrings);
  const task = useSelector(state => state.forms.task);
  const state = useSelector(state => state.forms);
  const user = useSelector(state => state.user);
  const documents = useSelector(state => state.forms.documents);
  const businessKey = useSelector(state => state.forms.businessKey);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [outcome, setOutcome] = useState('');
  const [isVisible, setIsVisible] = useState(false);
  const [tooltipVisible, setTooltipVisible] = useState('');
  const params = useParams();
  const location = useLocation();
  

  useEffect(() => {
    // Code to run on component mount
    if(isVisible && isAuditor(user?.groups)){
      setOutcome('return')
    }
  }, [isVisible]); 

  useEffect(() => {
    // Code to run when 'current' changes
  }, [current]);

  const commonActions = [
    current !== 0 && {
      label: getLocalString(locales, localNames.REQUEST_PAGE_PREVIOUSBUTTON),
      type: 'default',
      className: 'dark-grey',
      onClick: () => {
        setCurrent(current - 1);
      }
    },
    current !== (!isNil(steps) ? steps.length - 1 : tabs.length - 1) && {
      label: getLocalString(locales, localNames.REQUEST_PAGE_NEXTBUTTON),
      type: 'primary',
      className: 'brown-grey',
      onClick: () => {
        setCurrent(current + 1);
      }
    },
  ].filter(Boolean);

  const commonActionsSub = [
    (currentSubTab !== 0 || current !== 0) && {
      label: 'Προηγούμενο',
      type: 'default',
      className: 'dark-grey',
      onClick: () => currentSubTab !== 0? dispatch(
        updateFormField({
          group: 'carrier',
          key:'currentSubTab',
          value: currentSubTab -1 ,
        })
      ) : setCurrent(current - 1)
      //onClick: () => showBankTab ? setCurrent(current - 1) : current === 1 ? setCurrent(current - 1) : setCurrent(current - 2),
    },
    (current !== (tabs.length - 1 ) || currentSubTab !==tabs[current]?.tabsComponent?.length -1) && {
      label: 'Επόμενο',
      type: 'primary',
      className: 'brown-grey',
      onClick: () => currentSubTab !== tabs[current]?.tabsComponent.length -1 ? dispatch(
        updateFormField({
          group: 'carrier',
          key:'currentSubTab',
          value: currentSubTab + 1 ,
        })
      ) : setCurrent(current + 1)
      //onClick: () => showBankTab ? setCurrent(current + 1) : current === 0 ? setCurrent(current + 1) : setCurrent(current + 2),
    },
  ].filter(item => item);

  const rejectActions = [
    {
      label: 'Επιστροφή στον Δικαιούχο',
      id: 'return-to-investor',
      type: 'default',
      className: 'dark-grey',
      // tooltipTitle:
      //   'Επιστροφή για υποβολή αιτήματος αλλαγής στοιχείων / δικαιολογητικών',
      visible: tooltipVisible === 'return-to-investor',
      onVisibleChange: v => setTooltipVisible(v ? 'return-to-investor' : ''),
      onClick: () => {
        setIsVisible(true);
      },
      disabled: isEmpty(documents?.audDocsCompletenessReport),
    },
  ].filter(item => item);

  return (
    <div className="form-footer">
      <SubmitModal
        isVisible={isVisible}
        setIsVisible={setIsVisible}
        businessKey={businessKey}
        formKey={task.formKey}
        outcome={outcome}
        handleSubmit={() => handleSubmit({
          state: { ...state },
          user: { ...user },
          dispatch,
          submitTask,
          navigate,
          setIsVisible,
          taskId: params.taskId,
          formKey: task.formKey,
          outcome,
        })}
      />

      {/* Divider line */}
      <div className="form-footer__divider"></div>

      {/* Wrapper to handle button alignment */}
      <div className="form-footer__actions-wrapper">
        {isAuditor(user?.groups) && currentSubTab === 1 && (
        <div className="form-footer__actions">
            {rejectActions.map((action, index) => (
              <Tooltip
                key={index}
                title={action.tooltipTitle}
                visible={action.visible}
                onVisibleChange={action.onVisibleChange}
              >
                <Button
                  key={index}
                  {...omit(action, [
                    'tooltipTitle',
                    'visible',
                    'onVisibleChange',
                  ])}
                />
              </Tooltip>
            ))}
        </div>
        )}
        <div className="form-footer__actions right-placement ">
          {tabs[current].subtabs ? commonActionsSub.map((action, index) => (
            <Button key={index} {...action} />
          )) : 
          commonActions.map((action, index) => (
            <Button key={index} {...action} />
          ))}
        </div>
        {/* <ReturnModal
          isVisible={isVisible}
          setVisible={setIsVisible}
          // entity={entity}
          formKey={task.formKey}
          state={state}
          user={user}
        /> */}
      </div>
    </div>
  );
};

export default FormFooter;
